import { useState } from "react";
import { useTrial } from "../context/TrialContext";
import TrialPopup from "./TrialPopup";

const useTrialExp = () => {
  const { trialExpired } = useTrial();
  const [showPopup, setShowPopup] = useState(false);

  const guard = (action) => {
    if (trialExpired) {
      setShowPopup(true);
      return;
    }
    action();
  };

  const Popup = () => (
    <TrialPopup
      show={showPopup}
      onClose={() => setShowPopup(false)}
    />
  );

  return { guard, Popup };
};
export default useTrialExp;
